/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface McpGrantResponse
 */
export interface McpGrantResponse {
    /**
     * 
     * @type {string}
     * @memberof McpGrantResponse
     */
    grantId: string;
    /**
     * 
     * @type {string}
     * @memberof McpGrantResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof McpGrantResponse
     */
    clientName: string;
    /**
     * 
     * @type {string}
     * @memberof McpGrantResponse
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof McpGrantResponse
     */
    projectName: string;
    /**
     * 
     * @type {string}
     * @memberof McpGrantResponse
     */
    resource: string;
}

/**
 * Check if a given object implements the McpGrantResponse interface.
 */
export function instanceOfMcpGrantResponse(value: object): value is McpGrantResponse {
    if (!('grantId' in value) || value['grantId'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('projectName' in value) || value['projectName'] === undefined) return false;
    if (!('resource' in value) || value['resource'] === undefined) return false;
    return true;
}

export function McpGrantResponseFromJSON(json: any): McpGrantResponse {
    return McpGrantResponseFromJSONTyped(json, false);
}

export function McpGrantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): McpGrantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'grantId': json['grantId'],
        'clientId': json['clientId'],
        'clientName': json['clientName'],
        'projectId': json['projectId'],
        'projectName': json['projectName'],
        'resource': json['resource'],
    };
}

export function McpGrantResponseToJSON(json: any): McpGrantResponse {
    return McpGrantResponseToJSONTyped(json, false);
}

export function McpGrantResponseToJSONTyped(value?: McpGrantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'grantId': value['grantId'],
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'projectId': value['projectId'],
        'projectName': value['projectName'],
        'resource': value['resource'],
    };
}

